<script>
export default {
    name: 'ListaVaziaIcone'
};
</script>

<template>
    <svg width="121" height="99" viewBox="0 0 121 99" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_148_7259)">
            <path
                d="M60.6033 99.4921C85.237 99.4921 105.207 95.7608 105.207 91.1579C105.207 86.5551 85.237 82.8237 60.6033 82.8237C35.9696 82.8237 16 86.5551 16 91.1579C16 95.7608 35.9696 99.4921 60.6033 99.4921Z"
                fill="#F5F5F7"
                fill-opacity="0.8"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M96.2854 66.6734L80.5452 47.3017C79.79 46.3899 78.686 45.8379 77.5235 45.8379H43.6814C42.5196 45.8379 41.4156 46.3899 40.6604 47.3017L24.9209 66.6734V76.7938H96.286V66.6734H96.2854Z"
                fill="#AEB8C2"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M38.2566 20.8354H82.9493C83.6473 20.8354 84.3166 21.1127 84.8102 21.6062C85.3037 22.0997 85.5809 22.7691 85.5809 23.467V84.8775C85.5809 85.5755 85.3037 86.2448 84.8102 86.7383C84.3166 87.2319 83.6473 87.5091 82.9493 87.5091H38.2566C37.5586 87.5091 36.8893 87.2319 36.3958 86.7383C35.9023 86.2448 35.625 85.5755 35.625 84.8775V23.467C35.625 22.7691 35.9023 22.0997 36.3958 21.6062C36.8893 21.1127 37.5586 20.8354 38.2566 20.8354V20.8354Z"
                fill="#F5F5F7"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M44.0776 27.3833H77.1283C77.4773 27.3833 77.812 27.5219 78.0587 27.7687C78.3055 28.0154 78.4441 28.3501 78.4441 28.6991V45.1182C78.4441 45.4671 78.3055 45.8018 78.0587 46.0486C77.812 46.2953 77.4773 46.434 77.1283 46.434H44.0776C43.7287 46.434 43.394 46.2953 43.1472 46.0486C42.9005 45.8018 42.7619 45.4671 42.7619 45.1182V28.6991C42.7619 28.3501 42.9005 28.0154 43.1472 27.7687C43.394 27.5219 43.7287 27.3833 44.0776 27.3833V27.3833ZM44.25 53.5767H76.9559C77.3506 53.5767 77.7291 53.7335 78.0082 54.0126C78.2873 54.2917 78.4441 54.6702 78.4441 55.0649C78.4441 55.4596 78.2873 55.8381 78.0082 56.1172C77.7291 56.3963 77.3506 56.553 76.9559 56.553H44.25C43.8553 56.553 43.4768 56.3963 43.1977 56.1172C42.9186 55.8381 42.7619 55.4596 42.7619 55.0649C42.7619 54.6702 42.9186 54.2917 43.1977 54.0126C43.4768 53.7335 43.8553 53.5767 44.25 53.5767V53.5767ZM44.25 61.3155H76.9559C77.3507 61.3155 77.7293 61.4724 78.0085 61.7515C78.2876 62.0307 78.4444 62.4093 78.4444 62.804C78.4444 63.1988 78.2876 63.5774 78.0085 63.8565C77.7293 64.1357 77.3507 64.2925 76.9559 64.2925H44.25C43.8552 64.2925 43.4766 64.1357 43.1975 63.8565C42.9184 63.5774 42.7615 63.1988 42.7615 62.804C42.7615 62.4093 42.9184 62.0307 43.1975 61.7515C43.4766 61.4724 43.8552 61.3155 44.25 61.3155V61.3155ZM96.1402 89.9353C95.6303 91.9557 93.8395 93.4616 91.7092 93.4616H29.4967C27.3665 93.4616 25.5757 91.955 25.0665 89.9353C24.9693 89.5503 24.9203 89.1547 24.9204 88.7576V66.6741H42.2349C44.1474 66.6741 45.6888 68.2846 45.6888 70.2399V70.2662C45.6888 72.2208 47.248 73.7991 49.1605 73.7991H72.0454C73.9579 73.7991 75.5171 72.2063 75.5171 70.2511V70.2432C75.5171 68.2879 77.0586 66.6734 78.9711 66.6734H96.2855V88.7583C96.2855 89.1642 96.2349 89.5583 96.1402 89.9353V89.9353Z"
                fill="#DCE0E6"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M98.3166 21.9026L93.8232 23.6461C93.7078 23.6909 93.582 23.7023 93.4604 23.6789C93.3388 23.6555 93.2263 23.5982 93.1357 23.5137C93.0452 23.4292 92.9804 23.3208 92.9487 23.2011C92.9171 23.0813 92.9199 22.9551 92.9568 22.8368L94.2311 18.7533C92.5278 16.8164 91.5278 14.4546 91.5278 11.9059C91.5278 5.33026 98.1844 0 106.396 0C114.606 0 121.263 5.33026 121.263 11.9059C121.263 18.4816 114.607 23.8118 106.396 23.8118C103.417 23.8118 100.643 23.1105 98.3166 21.9026Z"
                fill="#DCE0E6"
            />
            <path
                d="M112.253 14.056C113.288 14.056 114.127 13.2268 114.127 12.204C114.127 11.1812 113.288 10.3521 112.253 10.3521C111.218 10.3521 110.378 11.1812 110.378 12.204C110.378 13.2268 111.218 14.056 112.253 14.056Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M102.413 13.8243H98.6646L100.571 10.5835L102.413 13.8243ZM104.756 10.5835H108.036V13.8243H104.756V10.5835Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_148_7259">
                <rect width="121" height="99" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<style scoped></style>
